<template>
  <div class="emulsifying-cleansing-about-nyuka wrap space-150p space-btm-100p">
    <div class="inner-block">
      <h2 style="font-family: '游明朝', '游明朝体'">
        乳化クレンジングに<br class="sp-only" />使用するアイテム
      </h2>
      <p>
        ずばり、ドクターリセラのピュアモイスチャークレンジングを使用します。
      </p>
      <div class="pure-moist">
        <img
          alt="ピュアモイスチャークレンジング"
          src="@/assets/fushimi-HP-nyuka-005.jpg"
        />
      </div>
      <p>
        ドクターリセラのピュアモイスチャークレンジングは、水溶性で、石油系の合成界面活性剤を始めとする、お肌に悪いとされる成分が一切入っていません。これまで、ありとあらゆるクレンジングをチェックしてきましたが、このピュアモイスチャークレンジングが乳化クレンジングにおいてベストなアイテムです。石油系の合成界面活性剤による悪い影響は後述しますが、ドクターリセラのピュアモイスチャークレンジングを使用して、皮脂を乳化させていきます。<br />その方法については、上の動画内で説明していますので、そちらで実演をご覧ください。
      </p>
    </div>
    <div class="inner-block">
      <h2 style="font-family: '游明朝', '游明朝体'">
        世の中に出回っている<br class="sp-only" />乳化クレンジングとの違い
      </h2>
      <p>
        最近、「乳化クレンジング」という言葉が世の中に広がりつつあります。YouTubeを見ると、乳化クレンジングについて発信している動画が見つかります。しかし、その多くは、僕が考案し、提唱する乳化クレンジングとは異なる方法を説明しています。<br />僕が考案した乳化クレンジングとの違い、それは、「オイル系のクレンジングを使用していて、そのオイル系のクレンジングを残留させるのはお肌に悪影響。だから、流す前に、水をふりかけて、オイル系のクレンジングのオイルと水を乳化させて、流れやすくしましょう」というものです。<br />乳化の対象が、僕が提唱する「皮脂と水」ではなく、「オイル系クレンジングのオイルと水」なのです。<br />この理論は、僕が提唱する乳化クレンジングと定義は異なりますが、間違いではなく、これはこれで正解です。<br />「オイル系のクレンジングに含まれるオイルがお肌に悪い」という認識は、僕も全く同じです。そして、「そのオイルを水と混ぜ合わせて乳化させて、流れやすくした方がよい」ということも同意です。<br />オイル系のクレンジングには、石油系の界面活性剤が使われていることが多く、これがお肌に確実に悪影響を及ぼします。<br />このことを実感するために、食器洗剤でお皿を洗うことを思い浮かべてみてください。毎日、食器洗剤を使ってお皿洗をしていると、手が荒れますよね？
      </p>
      <img
        alt="食器洗いイメージ"
        src="@/assets/fushimi-HP-nyuka-006.jpg"
      />
      <p>
        これは、食器洗剤に含まれる石油系の合成界面活性剤が原因です。合成界面活性剤は、水と油の分離をなくすためのもので、洗剤や化粧品に含まれている場合が多いです。合成界面活性剤には、高い毒性・浸透性・残留性があります。汚れを落とす、掃除という点ではとても良いのですが、人体への影響という点では、高い毒性があり、人の細胞膜を破壊してしまいます。そのため、日々使用していると、手荒れが起きるのです。<br />石油系合成界面活性剤の毒性の実験として、アジの入った水槽に、石油系の合成界面活性剤を入れると、数秒もすると、アジが弱り、死んでしまう、というものがあります。石油系の合成界面活性剤には、このように明らかな毒性があります。<br />人間の細胞は60兆個もあるため、少しのことでは影響は受けません。しかし、お顔の皮膚においては、その影響を長く受けている人とそうでない人では大きな差が出てしまいます。特に、毎日オイル系のクレンジングを使用している人と、そうでない人の差は開くばかりです。<br />このように、「オイル系のクレンジングに含まれる成分がお肌に悪影響だから、水をふりかけて、乳化させてて、流れやすくしましょう」という点については同意です。<br />オイル系のクレンジングを使用しているが、水をふりかけて乳化させることなく、洗い流している人よりも、お肌を良い状態で保つことができるようになります。<br />しかし、ここで立ち止まると、1つ疑問が出ててくることになります。それは、「わざわざお肌に悪いとされるオイル系のクレンジングを使う理由があるのか？」「そもそもオイル系のクレンジングを使わないことが大切ではないか」という疑問です。
      </p>
    </div>

    <div class="inner-block">
      <h2 style="font-family: '游明朝', '游明朝体'">
        オイル系クレンジングによる<br class="sp-only" />お肌への悪影響
      </h2>
      <p>
        ここまで説明してきたとおり、世の中で言われている乳化クレンジングは、オイル系のクレンジングを使用することが前提となっていて、そもそも、このオイル系のクレンジングがお肌に悪影響を及ぼすため、その影響を少なくするために、水をふりかけて、乳化させて、流れやすくしましょう、というものです。<br />それならば、オイル系のクレンジング自体を使用しないことが一番です。オイル系のクレンジンに含まれる油による酸化と、オイル系クレンジングに含まれる石油系の合成界面活性剤などお肌に悪影響を及ぼす要因をなくすことができます。
      </p>
    </div>

    <div class="inner-block">
      <h2 style="font-family: '游明朝', '游明朝体'">
        お肌に悪影響のない<br class="sp-only" />クレンジングの方法
      </h2>
      <p>
        オイル系のクレンジング、メイクなどを一切しようしないことです。そうすれば、お肌に悪影響を及ぼす要因をなくすことができます。しっかり荒い流す、流れやすくする以前に、一切使用しないことが一番です。<br />そして、この状態で、ドクターリセラのピュアモイスチャークレンジングを伏見式の使用方法で使用した乳化クレンジングで、毛穴の皮脂と水溶性ジェルクレンジングを乳化させて、毛穴の中の皮脂の汚れをしっかりと除去することです。<br />これによって、皮脂による酸化はもちろん、化粧品による悪影響も避けることができ、あなたのお肌が理想的な状態になっていきます。
      </p>
    </div>
    <div class="inner-block">
      <h2 style="font-family: '游明朝', '游明朝体'" class="back-black">
        乳化クレンジングのまとめ
      </h2>
      <table>
        <tr>
          <th class="blue-back"></th>
          <td class="blue-text blue-back">伏見式<br />乳化クレンジング</td>
          <td class="blue-back">世の中で言われている 乳化クレンジング</td>
        </tr>
        <tr>
          <th>使用する<br class="sp-only">クレンジング</th>
          <td class="blue-text">
            水溶性<br class="sp-only" />ジェルクレンジング<br />
            <span>※ドクターリセラのピュアモイスチャークレンジング</span>
          </td>
          <td>オイル系の<br class="sp-only" />クレンジング</td>
        </tr>
        <tr>
          <th>お肌に悪いとされる成分</th>
          <td class="blue-text">なし</td>
          <td>オイル、石油系の<br class="sp-only" />界面活性剤、香料、など</td>
        </tr>
        <tr>
          <th>乳化の対象</th>
          <td class="blue-text">
            「皮脂」と<br class="sp-only" />「水溶性ジェルクレンジング」
          </td>
          <td>「オイル系クレンジングの油」と「水」</td>
        </tr>
      </table>
    </div>

    <!-- <div class="inner-block">
      <h2 style="font-family: '游明朝', '游明朝体'">
        乳化クレンジングの注意点
      </h2>
      <p>現在準備中です</p>
      <p>現在準備中です</p>
      <p>現在準備中です</p>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import UiHeading from "@/components/Ui/Heading.vue";
// import UiFushimiHistory from "@/components/Ui/FushimiHistory.vue";
// import UiYoutubeButton from "@/components/Ui/YoutubeButton.vue";

export default {
  name: "HomeMap",
  components: {
    // UiBox,
    // UiHeading,
    // UiFushimiHistory,
    // UiYoutubeButton,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.inner-block {
  margin-bottom: 150px;
    padding: 0 100px;
  @media screen and (max-width: 767px) {
    margin-bottom: 80px;
    padding: 0;
  }
  h2 {
    text-align: center;
    margin-bottom: 50px;
    @media screen and (max-width: 767px) {
      margin-bottom: 30px;
    }
  }
  .back-black {
    background-color: var(--black);
    color: white;
    padding: 10px 0;
  }
  p,
  img {
    margin-bottom: 50px !important;
    @media screen and (max-width: 767px) {
      margin-bottom: 30px !important;
    }
  }
  .pure-moist {
    text-align: center;
    img {
      width: 50%;
      @media screen and (max-width: 767px) {
        width: 70%;
      }
    }
  }
  table {
    width: 100%;
    tr {
      th,
      td {
        border: 1px solid var(--black);
        padding: 20px 0;
        text-align: center;
        vertical-align: middle;
        font-weight: bold;
        line-height: 1.4em;
        @media screen and (max-width: 767px) {
          font-size: 13px;
          padding: 20px 5px;
        }
      }
      th {
        width: 22%;
        @media screen and (max-width: 767px) {
          // white-space:nowrap;
          // -ms-writing-mode: tb-rl;
          // -webkit-writing-mode: vertical-rl;
          // writing-mode: vertical-rl;
          // -webkit-text-orientation: upright;
          // text-orientation: upright;
          width: 26%;
          // span{
          //   display: block;
          // }
        }
      }
      td {
        width: 39%;
        background-color: white;
      }
      .blue-text {
        color: #0077bb;
      }
      .blue-back {
        background-color: rgb(193, 233, 249);
      }
      span {
        font-size: 14px;
        @media screen and (max-width: 767px) {
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
